'use client';
import { useEffect } from 'react';

interface ClientScriptsProps {
  chewyEnv: string;
}

export default function ClientScripts({ chewyEnv }: ClientScriptsProps) {
  const dynatraceScriptSrc =
    chewyEnv !== 'prd'
      ? 'https://js-cdn.dynatrace.com/jstag/1624d0f62e6/bf86761hnn/50b77f04c45ce7f4_complete.js'
      : 'https://js-cdn.dynatrace.com/jstag/1624d0f62e6/bf20861wzf/e1b02228925e756e_complete.js';

  useEffect(() => {
    // Dynamically load Dynatrace script
    if (chewyEnv) {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = dynatraceScriptSrc;
      script.crossOrigin = 'anonymous';
      script.async = true;
      document.head.appendChild(script);

      // Cleanup function
      return () => {
        if (script.parentNode) {
          document.head.removeChild(script);
        }
      };
    }
  }, [chewyEnv, dynatraceScriptSrc]);

  // This component doesn't render anything, it just loads scripts
  return null;
}
